var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 2950 1707.2",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_etv742x7IiNKRKnwGEtYEMvb7BCpGorP"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2950,
    height: 1707.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_etv742x7IiNKRKnwGEtYEMvb7BCpGorP)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_ZDYMEOsu4YpWiWrpMPl5EhbxyObXZuLN"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.02,
    width: 2950,
    height: 1707.159,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_ZDYMEOsu4YpWiWrpMPl5EhbxyObXZuLN)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.156,
    y: -81.98,
    width: 3183.844,
    height: 2001.673,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(2,101,244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 103.156 2154.825 C 382.773 2227.655 648.541 1955.97 878.336 1729.491 C 1098.195 1512.804 1283.023 1233.854 1383.533 892.92 C 1481.103 561.957 1455.917 203.173 1432.877 -151.545 C 1408.561 -525.913 1452.615 -974.541 1245.837 -1227.024 C 1037.567 -1481.33 699.605 -1285.903 427.16 -1379.562 C 168.851 -1468.361 -49.142 -1866.044 -303.776 -1759.737 C -559.11 -1653.138 -589.845 -1177.327 -749.239 -888.431 C -893.108 -627.674 -1114.053 -451.564 -1194.493 -145.337 C -1284.507 197.341 -1366.524 612.779 -1224.857 922.204 C -1082.564 1232.997 -723.833 1163.102 -500.557 1370.341 C -265.528 1588.488 -177.13 2081.821 103.156 2154.825 Z ",
    fill: "rgb(0,25,73)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground2);
export default __webpack_public_path__ + "static/media/background2.add6ab40ba5c0bd16fbea212e4586d78.svg";
export { ForwardRef as ReactComponent };